/**
 * Class deposit display helpers (amount from site settings).
 */

import { formatClassDepositUsd } from '@lambda/shared/classDeposit';

export {
  DEFAULT_CLASS_DEPOSIT_CENTS,
  formatClassDepositUsd,
  normalizeClassDepositCents,
} from '@lambda/shared/classDeposit';

/** How-to-join step description on the landing page. */
export function classDepositHowToJoinDescription(feeCents: number): string {
  const amount = formatClassDepositUsd(feeCents);
  return `Once signed up, pay the ${amount} nonrefundable deposit fee per class to secure your student's spot. Tutors typically accept Venmo, PayPal, or cash. Classes fill quickly!`;
}

/** Short notice beside Enroll / in the enroll modal. */
export function classDepositEnrollNotice(feeCents: number): {
  title: string;
  body: string;
} {
  const amount = formatClassDepositUsd(feeCents);
  return {
    title: `${amount} nonrefundable deposit`,
    body: "Pay the tutor to secure your child's spot. Enrollment alone does not hold the seat.",
  };
}

/** Dollars input → cents for API (whole dollars). */
export function classDepositDollarsToCents(dollars: number): number {
  if (!Number.isFinite(dollars)) return 0;
  return Math.round(dollars * 100);
}

/** Cents → whole dollars for admin form field. */
export function classDepositCentsToDollars(cents: number): number {
  return cents / 100;
}
